/**
 * Serializes Shopify Cart Ajax API calls to avoid 429 rate limits.
 * Shared by sa-cart-bundle and sa-product-customize-look.
 */
(function () {
  let chain = Promise.resolve();
  const RETRY_DELAYS_MS = [400, 800, 1600];

  function enqueue(task) {
    const result = chain.then(() => task());
    chain = result.catch(() => {});
    return result;
  }

  async function fetchWithRetry(url, options = {}, maxRetries = RETRY_DELAYS_MS.length) {
    let lastResponse;

    for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
      lastResponse = await fetch(url, options);

      if (lastResponse.status !== 429 || attempt >= maxRetries) {
        return lastResponse;
      }

      await new Promise((resolve) => {
        window.setTimeout(resolve, RETRY_DELAYS_MS[attempt] || 1600);
      });
    }

    return lastResponse;
  }

  async function parseJsonResponse(response) {
    const text = await response.text();

    try {
      return JSON.parse(text);
    } catch {
      throw new Error(
        text.includes('<!DOCTYPE')
          ? 'Cart request failed. Please refresh the page and try again.'
          : 'Invalid response from cart API.',
      );
    }
  }

  window.SaCartApi = {
    enqueue,
    fetchWithRetry,
    parseJsonResponse,
  };
})();
